// ─── Which row a single-value tile shows (Looker's "Primary Row") ────────────
// Looker's single value vis has a Primary Row choice — 1st · 2nd · Last ·
// Total — stored as vis_config.primary_row. Pulse always read the FIRST row,
// so a tile set to "Total" (e.g. a merged "Forecasted Tickets Sold" across two
// events) showed one event's number instead of the sum.
//
// Returns the row object whose cells the tile reads (the totals row acts as a
// row: totals_data is keyed by field like any data row), or null with no data.
// "total" without a totals row falls back to the first row, as before.
// Mirrored in server/query.js (pickPrimaryRow) — keep the two in sync.
export function primaryRowOf(data, visConfig = {}) {
  const rows = (data && Array.isArray(data.data)) ? data.data : [];
  const want = String((visConfig && visConfig.primary_row) ?? '').trim().toLowerCase();
  const totals = data && data.totals_data && typeof data.totals_data === 'object' && Object.keys(data.totals_data).length ? data.totals_data : null;
  if ((want === 'total' || want === 'totals') && totals) return totals;
  if (!rows.length) return null;
  if (want === 'last') return rows[rows.length - 1];
  if (want === 'second' || want === '2nd' || want === '2' || want === '1') return rows[1] || rows[0];
  return rows[0];
}
